import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/api";
import { useAuth } from "@/auth";
import { PrimaryButton } from "@/ui";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const { applySession } = useAuth();

  const [state, setState] = useState("checking"); // checking | ready | invalid
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!token) { setState("invalid"); setErrMsg("Link non valido."); return; }
      try {
        const res = await api.checkPasswordToken(token);
        if (!alive) return;
        setEmail(res.email);
        setState("ready");
      } catch (e) {
        if (!alive) return;
        setErrMsg(e.message || "Link non valido o scaduto.");
        setState("invalid");
      }
    })();
    return () => { alive = false; };
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    if (pw.length < 6) { toast.error("La password deve avere almeno 6 caratteri"); return; }
    if (pw !== pw2) { toast.error("Le due password non coincidono"); return; }
    setBusy(true);
    try {
      const res = await api.setPassword(token, pw);
      const u = applySession(res);
      toast.success("Password impostata. Benvenuto!");
      navigate(u.role === "ADMIN" ? "/admin" : "/client/dashboard", { replace: true });
    } catch (err) {
      toast.error(err.message || "Operazione non riuscita");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="theme-brand min-h-screen bg-[#12100E] text-[#FAF7F2] flex flex-col">
      <div className="px-6 md:px-10 pt-8">
        <div className="font-display text-xl">YU <span className="text-[#E05A2C]">YieldUp</span></div>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md fade-up">
          <div className="eyebrow text-[#E05A2C] mb-5">Attivazione accesso</div>

          {state === "checking" && (
            <p className="text-[#C4BBB0]">Verifica del link in corso…</p>
          )}

          {state === "invalid" && (
            <div>
              <h1 className="font-display text-2xl md:text-3xl uppercase">Link non valido</h1>
              <p className="mt-4 text-[#C4BBB0] font-light">{errMsg}</p>
              <button onClick={() => navigate("/login")} className="mt-8 rounded-full border border-[#2A241F] px-6 py-3 text-[#FAF7F2] hover:border-[#E05A2C] transition-colors">
                Vai al login
              </button>
            </div>
          )}

          {state === "ready" && (
            <div>
              <h1 className="font-display text-2xl md:text-3xl uppercase">Scegli la tua password</h1>
              <p className="mt-3 text-[#C4BBB0] font-light">Accesso per <span className="text-[#FAF7F2]">{email}</span></p>
              <form onSubmit={submit} className="mt-8 space-y-4">
                <input
                  type="password" value={pw} onChange={(e) => setPw(e.target.value)}
                  placeholder="Nuova password" autoComplete="new-password"
                  className="w-full rounded-full bg-[#1C1815] border border-[#2A241F] px-5 py-3 outline-none focus:border-[#E05A2C] transition-colors"
                  required
                />
                <input
                  type="password" value={pw2} onChange={(e) => setPw2(e.target.value)}
                  placeholder="Ripeti la password" autoComplete="new-password"
                  className="w-full rounded-full bg-[#1C1815] border border-[#2A241F] px-5 py-3 outline-none focus:border-[#E05A2C] transition-colors"
                  required
                />
                <div className="pt-3">
                  <PrimaryButton type="submit" disabled={busy} className="w-full">
                    {busy ? "Salvataggio…" : "Salva e accedi"}
                  </PrimaryButton>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
